import { createAction } from '@reduxjs/toolkit';

import {
  REGISTRATIONS_LIST_RESET,
  REGISTRATIONS_LIST_FETCH_START,
  REGISTRATIONS_LIST_FETCH_SUCCESS,
  REGISTRATIONS_LIST_FETCH_FAILURE,
} from './registrationsList.const';

export const registrationsListResetAction = createAction(REGISTRATIONS_LIST_RESET);

export const registrationsListFetchStartAction = createAction(REGISTRATIONS_LIST_FETCH_START);
export const registrationsListFetchSuccessAction = createAction(REGISTRATIONS_LIST_FETCH_SUCCESS);
export const registrationsListFetchFailureAction = createAction(REGISTRATIONS_LIST_FETCH_FAILURE);
